import { SessionFetchParameters } from "common/build/api-parameters/session";
import React from "react";
import { get } from "../../../client/api/session";
import { FetchProvider } from "../../../core/components/crud/contexts/fetch.context";
import { SessionModeProvider } from "../../session/sessionMode/contexts/sessionMode.context";
import { ClassSessionWizard } from "./ClassSessionWizard";

export const ClassSessionScreen = (): JSX.Element => {
    return (
        <SessionModeProvider>
            <FetchProvider noun={"session"} getItem={get} includes={{ includeStory: true } as SessionFetchParameters}>
                <ClassSessionWizard />
            </FetchProvider>
        </SessionModeProvider>
    );
};
